import { Route } from "react-router-dom";
import LessonPlanningTools from "@features/lesson-planner/components/LessonPlanningTools";
import DailyLessonPlan from "@features/lesson-planner/components/daily_plan/DailyLessonPlan";
import NewPastDailyPlans from "@features/lesson-planner/components/daily_plan/NewPastDailyPlans";
import MaarifDailyLessonPlan from "@features/lesson-planner/components/maarif_daily_plan/MaarifDailyLessonPlan";
import NewPastMaarifDailyPlans from "@features/lesson-planner/components/maarif_daily_plan/NewPastMaarifDailyPlans";
import PastUbdMaarifPlans from "@features/lesson-planner/components/ubd_maarif_plan/PastUbdMaarifPlans";
import UbdMaarifLessonPlan from "@features/lesson-planner/components/ubd_maarif_plan/UBDMaarifLessonPlan";
import TedLessonPlan from "@features/lesson-planner/components/ted_plan/TedLessonPlan";
import PastTedPlans from "@features/lesson-planner/components/ted_plan/PastTedPlans";
import CreateTedPlanView from "@features/lesson-planner/components/ted_plan/CreateTedPlanView";

export const lessonPlannerRoutes = [
  <Route
    key="lesson-planning-tools-landing"
    path="/lesson-planning-tools"
    element={<LessonPlanningTools />}
  />,
  <Route
    key="lesson-planning-tools-daily"
    path="/lesson-planning-tools/daily-plan"
    element={<NewPastDailyPlans />}
  />,
  <Route
    key="lesson-planning-tools-daily-new"
    path="/lesson-planning-tools/daily-plan/new"
    element={<DailyLessonPlan />}
  />,
  <Route
    key="lesson-planning-tools-daily-edit"
    path="/lesson-planning-tools/daily-plan/:planId"
    element={<DailyLessonPlan />}
  />,
  <Route
    key="lesson-planning-tools-maarif-daily"
    path="/lesson-planning-tools/maarif-daily-plan"
    element={<NewPastMaarifDailyPlans />}
  />,
  <Route
    key="lesson-planning-tools-maarif-daily-new"
    path="/lesson-planning-tools/maarif-daily-plan/new"
    element={<MaarifDailyLessonPlan />}
  />,
  <Route
    key="lesson-planning-tools-maarif-daily-edit"
    path="/lesson-planning-tools/maarif-daily-plan/:planId"
    element={<MaarifDailyLessonPlan />}
  />,
  <Route
    key="lesson-planning-tools-ubd-maarif"
    path="/lesson-planning-tools/ubd-maarif-plan"
    element={<PastUbdMaarifPlans />}
  />,
  <Route
    key="lesson-planning-tools-ubd-maarif-new"
    path="/lesson-planning-tools/ubd-maarif-plan/new"
    element={<UbdMaarifLessonPlan />}
  />,
  <Route
    key="lesson-planning-tools-ubd-maarif-edit"
    path="/lesson-planning-tools/ubd-maarif-plan/:planId"
    element={<UbdMaarifLessonPlan />}
  />,
  <Route
    key="lesson-planning-tools-ted-plan"
    path="/lesson-planning-tools/ted-plan"
    element={<PastTedPlans />}
  />,
  <Route
    key="lesson-planning-tools-ted-plan-new"
    path="/lesson-planning-tools/ted-plan/new"
    element={<CreateTedPlanView />}
  />,
  <Route
    key="lesson-planning-tools-ted-plan-edit"
    path="/lesson-planning-tools/ted-plan/:planId"
    element={<TedLessonPlan />}
  />,
];
